import * as React from 'react'
import {cn} from '@frontrow/console/src/lib/utils'

type Props = {
  label: React.ReactNode
  comment?: string
  addClass?: string
  children: React.ReactNode
}

// The text is a span rather than the shared Label, because a <label> inside a
// <label> is not valid HTML and browsers disagree on the accessible name it
// produces. These classes are Label's `label-2` variant.
const LABEL_TEXT = 'inline-block text-sm font-medium leading-none'

// The caller supplies the control, so its size and colour are set from here.
const CONTROL =
  '[&>input]:m-0 [&>input]:h-4 [&>input]:w-4 [&>input]:shrink-0 [&>input]:accent-primary'

export default function LabelledInput(props: Props): React.ReactElement {
  const {label, comment, children, addClass} = props

  const body =
    comment === null || comment === undefined ? (
      label
    ) : (
      <>
        {label} - <span className="font-normal">{comment}</span>
      </>
    )
  return (
    <label className={`m-0 flex cursor-pointer items-center gap-1.5 ${CONTROL}`}>
      {children}
      <span className={cn(LABEL_TEXT, addClass)}>{body}</span>
    </label>
  )
}
